var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFavoriteSolid = function SvgFavoriteSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.716 3.038c-.22-.701-1.212-.701-1.432 0L9.543 8.606a.75.75 0 0 1-.724.526l-5.834-.064c-.735-.008-1.042.936-.442 1.362L7.3 13.807a.75.75 0 0 1 .276.85l-1.863 5.53c-.235.696.568 1.28 1.158.84l4.681-3.48a.75.75 0 0 1 .896 0l4.681 3.48c.59.44 1.393-.144 1.159-.84l-1.864-5.53a.75.75 0 0 1 .276-.85l4.758-3.377c.599-.426.292-1.37-.443-1.362l-5.834.064a.75.75 0 0 1-.724-.526l-1.741-5.568Z"
  })));
};

export default SvgFavoriteSolid;